import { render, staticRenderFns } from "./MergeIcon.vue?vue&type=template&id=79274982"
import script from "./MergeIcon.vue?vue&type=script&lang=js"
export * from "./MergeIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports